import { FC } from 'react';

import { InputMod } from '@enums';
import type { BaseSelectInputProps } from '@types';
import { validateValueEqual } from '@utils';

import { BaseSelectInput, FilledSelectInput } from '.';

export const SelectInput: FC<BaseSelectInputProps> = ({ inputMod, ...props }) => {
  const isFilled = validateValueEqual(inputMod, InputMod.Filled);

  if (isFilled) {
    return <FilledSelectInput {...props} />;
  }

  return <BaseSelectInput {...props} label={undefined} />;
};
